import React from 'react';

import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

export const textFilterTemplate = (configuration) => {
  return (options) => {
    return (
      <InputText
        value={ options.value || '' }
        onChange={ (e) => options.filterApplyCallback(e.target.value) }
        placeholder={ configuration.placeholder || 'Buscar...' }
      />
    )
  }
}

export const simpleSelectFilterTemplate = (configuration) => {
  return (options) => {
    return (
      <Dropdown
        value={ options.value || '' }
        options={ configuration.options || []}
        onChange={ (e) => options.filterApplyCallback(e.value) }
        placeholder={ configuration.placeholder || 'Selecciona una opción' }
        className="p-column-filter"
      />
    )
  }
}
